//Scroll
import {gsap} from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

ScrollTrigger.create({
    trigger: "#pdw-header",      // L'élément qui sert de point de repère
    start: "bottom top",         // Quand le BAS du header touche le HAUT de l'écran
    toggleClass: {
        targets: document.body,  // L'élément sur lequel on ajoute la classe
        className: "scrolled"    // Le nom de la classe à ajouter/retirer
    }
});